import { render, staticRenderFns } from "./VeriffVerification.vue?vue&type=template&id=389105fe&scoped=true"
import script from "./VeriffVerification.vue?vue&type=script&lang=ts"
export * from "./VeriffVerification.vue?vue&type=script&lang=ts"
import style0 from "./VeriffVerification.vue?vue&type=style&index=0&id=389105fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389105fe",
  null
  
)

export default component.exports